/* @flow */
import { combineReducers } from 'redux-immutable';
import type { Action } from 'trustar/utils/redux-types.js';
import { fromJS } from 'trustar/utils';
import { pickImmutable } from 'trustar/utils';
import { Map, List, fromJS as ImmutableFromJS } from 'immutable';

import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  FETCH_QUOTAS,
  FETCH_QUOTAS_SUCCESS,
  FETCH_QUOTAS_FAILURE,
  UPDATE,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
  UPDATE_PREFERENCES_SUCCESS,
  HIDE_UPSELL_MODAL,
} from './action-types.js';
import { toProfile, Profile } from './types.js';
import type { RawProfile } from './types.js';

type State = typeof Profile;

export const profile = (state: State = Profile(), action: Action<RawProfile>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUCCESS:
  case UPDATE_SUCCESS:
  case UPDATE_PREFERENCES_SUCCESS:
    return fromJS(toProfile, payload);
  case FETCH_FAILURE:
    return Profile();
  default:
    return state;
  }
};

export const quotas = (state: State = List(), action: Action<RawProfile>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_QUOTAS_SUCCESS:
    return ImmutableFromJS(payload);
  case FETCH_QUOTAS_FAILURE:
    return List();
  default:
    return state;
  }
};

export const loading = (state: boolean = true, action: Action<any>) => {
  switch (action.type) {
  case FETCH:
  case UPDATE:
  case FETCH_QUOTAS:
    return true;
  case FETCH_QUOTAS_SUCCESS:
  case FETCH_QUOTAS_FAILURE:
  case FETCH_SUCCESS:
  case FETCH_FAILURE:
  case UPDATE_SUCCESS:
  case UPDATE_FAILURE:
    return false;
  default:
    return state;
  }
};

const seenUpsellModal = (state = false, action) => {
  const { type } = action;

  switch (type) {
  case HIDE_UPSELL_MODAL:
    return true;
  default:
    return state;
  }
};

export const serialize = (state: Map<any, any>) =>
  pickImmutable(['seenUpsellModal'], state);

export default combineReducers({
  quotas,
  profile,
  loading,
  seenUpsellModal,
});



// WEBPACK FOOTER //
// ./src/app/modules/profile/stores.js